'use client';

import { TradePlayerContent } from '@/components/molecules';
import { PlayerMovesSkeleton } from '@/components/molecules/skeletons/PlayerMovesSkeleton';
import { TeamLeaguesErrorPage } from '@/components/organisms/TeamLeaguesErrorPage';
import { useTeamLeagueTeamPlayersQuery } from '@/hooks/player-move/useTeamLeagueTeamPlayersQuery';
import { useMultipleTeamLeagueTeamsQuery, useTeamLeagueTeamsQuery } from '@/hooks/player-move/useTeamLeagueTeamsQuery';

export function TradePlayerWrapper({ teamId }: { teamId: string }) {
	const { data: players, isLoading: isLoadingPlayers } = useTeamLeagueTeamPlayersQuery(teamId);
	const { data: teams, isLoading: isLoadingTeams } = useMultipleTeamLeagueTeamsQuery();
	const { data: currentTeam, isLoading: isLoadingCurrentTeam } = useTeamLeagueTeamsQuery(teamId);

	if (isLoadingPlayers || isLoadingTeams || isLoadingCurrentTeam || !players || !teams || !currentTeam) {
		return <PlayerMovesSkeleton type="trade" />;
	}

	if (players.statusCode !== 200 || teams.statusCode !== 200 || currentTeam.statusCode !== 200) {
		return (
			<TeamLeaguesErrorPage
				title="Unforced error!"
				description=" We just hit out of bounds...Please try back later."
				shouldTakeScreenWidth={false}
			/>
		);
	}

	return <TradePlayerContent currentTeam={currentTeam.data!} teams={teams.data || []} players={players.data || []} />;
}
